import { initializeApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyAuhklIscixXHH9FZvAFAQwZBT2oK6Qj6w',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'wisdom-audio-library.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'wisdom-audio-library',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'wisdom-audio-library.firebasestorage.app',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export auth instance
export const auth: Auth = getAuth(app);

export default app;
